import React from "react";
import "./Banner.css";
import AboutBg from "../assets/banner.png";

export default function AboutHeader() {
  return (
    <section
      className="aheader-wrapper"
      style={{ backgroundImage: `url(${AboutBg})` }}
    >
      <div className="aheader-overlay">
        <h1 className="aheader-title">About Us</h1>
        <p className="aheader-breadcrumb">
          Home <span className="aheader-separator">›</span> About Us
        </p>
      </div>
    </section>
  );
}
